import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';
import device from "utils/device";

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 20px 0px;
    left: 0px;
    top: 100%;
    min-width: 300px;
    z-index: 10;

    max-height: 400px;
    overflow: auto;

    @media ${device.tablet} {
      left: ${displayState?.right ? 'unset' : '100%'};
      right: ${displayState?.right ? '100%' : 'unset'};
      top: ${displayState?.bottom ? 'unset' : '0px'};
      bottom: ${displayState?.bottom ? '0px' : 'unset'};
    }

    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;

    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
      background: #E3E3E3;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #E3E3E3;
    }
  `}
`;

export default Wrapper(template);